import React, {useEffect} from 'react';
import {CreateEditAccountModal} from '@ey/canvascoreservices';
import {useDispatch, useSelector} from 'react-redux';
import {getAvailablePSPIndexes} from '../../../actions/PSPIndexes/pspIndexesActions';
import {currentResource} from '../../../util/utils';
import {clearErrors} from '../../../actions/erroractions';
import {
	cleanManageAccount,
	createManageAccount,
	getManageAccountById,
	updateManageAccount
} from '../../../actions/Account/manageaccountsactions';
import Utility from '../../../util/utilityfunctions';
import {setIsModalOpen} from '../../../actions/setismodalopen';
import ErrorSummary from '../ErrorSummary/ErrorSummary';
import {clientSideEventNames} from '../../../util/uiconstants';

export default function CreateEditAccountModalWrapper(props) {
	const {
		isCreate,
		isEdit,
		showModal,
		setShowModal,
		accountId,
		onClose,
		createMinimalAccount,
		isManageAccounts,
		getAccountsForBody,
		onEditAccountAction,
		setIsEntityUpdated
	} = props;

	const engagementId = useSelector((state) => state.engagementId);
	const isGroupAuditEngagement = useSelector((state) => state?.engagement?.isGroupAuditEngagement);
	const [availablePSPIndexes, account] = useSelector((state) => [state.pspIndexes, state.manageAccount]);
	const dispatch = useDispatch();

	useEffect(() => {
		if (showModal) {
			dispatch(setIsModalOpen(true));
		} else {
			dispatch(setIsModalOpen(false));
		}
	}, [showModal]);

	const actionProps = {};
	if (isManageAccounts) {
		actionProps.isManageAccounts = isManageAccounts;
	}

	const _accountId = accountId || account.id;

	return (
		<>
			{isCreate && (
				<CreateEditAccountModal
					engagementId={Number(engagementId)}
					showModal={showModal}
					setShowModal={setShowModal}
					pspIndexes={availablePSPIndexes}
					createMinimalAccount={createMinimalAccount}
					createAccountAction={(acct) => {
						return dispatch(createManageAccount(engagementId, acct, actionProps)).finally(() => {
							window.dispatchEvent(new CustomEvent(clientSideEventNames.getValidations));
						});
					}}
					pspIndexAction={() => getAvailablePSPIndexes(engagementId, actionProps)}
					labels={currentResource.createEditAccountModalLabels}
					onClose={() => {
						isManageAccounts ? dispatch(cleanManageAccount()).finally(() => onClose?.()) : onClose?.();
					}}
					isGroupAuditEngagement={isGroupAuditEngagement}
					theme={Utility.getTheme()}
					errorComponent={<ErrorSummary />}
				/>
			)}
			{isEdit && (
				<CreateEditAccountModal
					engagementId={Number(engagementId)}
					showModal={showModal}
					setShowModal={setShowModal}
					pspIndexes={availablePSPIndexes}
					pspIndexAction={() => getAvailablePSPIndexes(engagementId, actionProps)}
					labels={currentResource.createEditAccountModalLabels}
					accountId={accountId || account.id}
					accountDetails={account}
					onClose={() => {
						dispatch(clearErrors());
						isManageAccounts ? dispatch(cleanManageAccount()).finally(() => onClose?.()) : onClose?.();
					}}
					editAccountAction={(acct) => {
						return dispatch(updateManageAccount(engagementId, _accountId, acct, actionProps))
							.then(() => {
								setIsEntityUpdated(true);
								onEditAccountAction && onEditAccountAction();
							})
							.finally(() => {
								window.dispatchEvent(new CustomEvent(clientSideEventNames.getValidations));
							});
					}}
					getAccountById={() =>
						getManageAccountById(
							Number(engagementId),
							Number(_accountId),
							{includeAssertions: true, includeRelatedRisks: true, includePspIndexes: true},
							actionProps
						)
					}
					isGroupAuditEngagement={isGroupAuditEngagement}
					theme={Utility.getTheme()}
					errorComponent={<ErrorSummary />}
				/>
			)}
		</>
	);
}
